import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { select, Store } from '@ngrx/store';
import {
  EMPTY,
  catchError,
  distinctUntilChanged,
  exhaustMap,
  from,
  map,
  of,
  switchMap,
} from 'rxjs';

import { JWTService } from 'ZalamoLibrary/src/lib/zalamo/auth/jwt-parser-service';
import { selectAuthStateState } from 'ZalamoLibrary/src/lib/zalamo/auth/redux/auth-state.selectors';
import { DeviceLoggedOutGQL } from '../graphql';

@Injectable({
  providedIn: 'root',
})
export class DeviceLogoutSubscriptionService {
  private started = false;

  constructor(
    private readonly store: Store,
    private readonly apollo: Apollo,
    private readonly jwtService: JWTService,
    private readonly deviceLoggedOutGQL: DeviceLoggedOutGQL,
  ) {}

  start() {
    if (this.started) {
      return;
    }

    this.started = true;
    this.store
      .pipe(
        select(selectAuthStateState),
        map(({ loggedIn }) => loggedIn),
        distinctUntilChanged(),
        switchMap((loggedIn) =>
          loggedIn
            ? this.deviceLoggedOutGQL
                .subscribe({})
                .pipe(catchError(() => EMPTY))
            : EMPTY,
        ),
        exhaustMap(() =>
          from(this.handleRemoteLogout()).pipe(catchError(() => of(null))),
        ),
      )
      .subscribe();
  }

  private async handleRemoteLogout() {
    await this.jwtService.logout(false);

    try {
      await this.apollo.client.clearStore();
    } catch (_error) {
      // Clear-store failures should not block logout redirect.
    }

    window.location.assign('/login');
  }
}
